import { chakra } from "@chakra-ui/react";
import * as React from "react";

export const Fb = (props: any) => (
  <chakra.svg
    width="28px"
    height="29px"
    viewBox="0 0 28 29"
    fill="none"
    flexShrink={0}
    {...props}
  >
    <g id="facebook" clipPath="url(#clip0_1046_35412)">
      <path
        id="Vector"
        d="M8.16406 11.903V16.5697H11.6641V24.7363H16.3307V16.5697H19.8307L20.9974 11.903H16.3307V9.56966C16.3307 9.26024 16.4536 8.9635 16.6724 8.7447C16.8912 8.52591 17.188 8.40299 17.4974 8.40299H20.9974V3.73633H17.4974C15.9503 3.73633 14.4666 4.35091 13.3726 5.44487C12.2786 6.53883 11.6641 8.02257 11.6641 9.56966V11.903H8.16406Z"
        stroke="#BB5D82"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1046_35412">
        <rect
          width="28"
          height="28"
          fill="white"
          transform="translate(0 0.236328)"
        />
      </clipPath>
    </defs>
  </chakra.svg>
);
